module.exports = __webpack_public_path__ + "img/video_bg3.d2f6d2ff.jpg";